<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  width: 100%;
  height:25vh;
  margin: 0 auto;
  color: #fff;
  text-align: center;


  .main {
    width: 100%;
    height: 100%;

    .list-item {
      background: #0B2574;
      margin: 0.5vh;
      line-height: 5.3vh;
      display: flex;

      .item {
        width: 25%;
      }
    }

    .list-item1 {
      color: #00FEFB;
      height: 5vh;
      background: url('../../../../../assets/img/helpPoor/top1.png') no-repeat;
      background-size: 100% 100%;
      line-height: 5vh;
      display: flex;

      .item {
        width: 25%;
      }
    }
  }
}
</style>

<template>
  <!-- <boxWrap :name="name"> -->
  <div class="table">
    <div class="main">
      <div class="list-item list-item1">
        <div class="item">贫困户</div>
        <div class="item">家庭人口</div>
        <div class="item">所在地</div>
        <div class="item">帮扶金额</div>
        <!-- <div class="item">上市周期</div> -->
      </div>
      <swiper :options="swiperOption" class="swiper-wrap" ref="mySwiper" v-if="tableData.length != 0">
        <swiper-slide v-for="(item, index) in tableData" :key="index" class="list-item">
          <div class="item">{{ item.poor }}</div>
          <div class="item">{{ item.familyPopulation }}</div>
          <div class="item">{{ item.regionName }}</div>
          <div class="item">{{ item.amount }}</div>
          <!-- <div class="item">{{item.listed}}</div> -->
        </swiper-slide>
      </swiper>
    </div>
  </div>
  <!-- </boxWrap> -->
</template>

<script>
import boxWrap from '../common/boxWrap';
// import '/../../../../static/css/swiper.css'
import '@/assets/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  props: ['povertyAlleviaList'],
  data() {
    return {
      name: '',
      tableData: [],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    // boxWrap,
    swiper,
    swiperSlide
  },
  mounted() {
    this.tableData = this.povertyAlleviaList
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?5c0f50b3